import type { SideBarOption } from '@aus-platform/design-system';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../../../app/store';
import type { Map3DSidebarState } from './types';

const map3DSidebarInitialState: Map3DSidebarState = {
  activeSidebarOption: null,
  isOverlayOpen: false,
  isOverlayDirty: false,
  showDiscardOverlayModal: false,
};

export const map3DSidebarSlice = createSlice({
  name: 'map3DSidebar',
  initialState: map3DSidebarInitialState,
  reducers: {
    resetMap3DSidebar: (state) => {
      Object.assign(state, map3DSidebarInitialState);
    },
    setActiveSidebarOption: (
      state,
      action: PayloadAction<SideBarOption | null>,
    ) => {
      Object.assign(state, {
        activeSidebarOption: action.payload,
      });
    },
    setOverlayDirty: (state, action: PayloadAction<boolean>) => {
      state.isOverlayDirty = action.payload;
    },
    toggleOverlay: (state) => {
      if (state.isOverlayOpen && state.isOverlayDirty) {
        state.showDiscardOverlayModal = true;
      } else {
        state.isOverlayOpen = !state.isOverlayOpen;

        if (!state.isOverlayOpen) {
          state.showDiscardOverlayModal = false;
        }
      }
    },
    closeOverlay: (state) => {
      state.isOverlayOpen = false;
      state.isOverlayDirty = false;
      state.showDiscardOverlayModal = false;
    },
    setShowDiscardOverlayModal: (state, action: PayloadAction<boolean>) => {
      state.showDiscardOverlayModal = action.payload;
    },
  },
});

// Actions.
export const {
  resetMap3DSidebar,
  setActiveSidebarOption,
  setOverlayDirty,
  toggleOverlay,
  closeOverlay,
  setShowDiscardOverlayModal,
} = map3DSidebarSlice.actions;

// Selectors.
export const selectMap3dSidebar = (state: RootState) =>
  state.map3d.map3dSidebar;

export const map3dSidebarReducer = map3DSidebarSlice.reducer;
